import {
  FormInput,
  validatePassword,
  validatePasswordsMatch,
  validateRequired,
} from 'components/shared/Forms/ReduxForm'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { adminChangePassword } from 'redux/userAdmin'
import { Button, Divider, Form } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { language } = state.navigation
  const { serverErrors } = state.user
  return { serverErrors, language }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      adminChangePassword,
    },
    dispatch
  )
}

class UserChangePassword extends React.PureComponent {
  render() {
    const {
      userId, //ownProps
      adminChangePassword, //connect
      handleSubmit,
      reset,
      invalid, //reduxForm
    } = this.props
    return (
      <Form>
        <Field
          component={FormInput}
          validate={[validateRequired, validatePassword]}
          type="password"
          size="tiny"
          placeholder={I18n.t('global.password')}
          name="password"
        />
        <Field
          component={FormInput}
          validate={[validateRequired, validatePassword]}
          type="password"
          size="tiny"
          placeholder={I18n.t('login.reset_password.password_confirmation')}
          name="password_confirmation"
        />
        <Button
          primary
          {...{
            disabled: invalid,
            content: I18n.t('login.reset_password.submit'),
            onClick: handleSubmit((formData) => {
              adminChangePassword({ ...formData, id: userId })
              reset()
            }),
          }}
        />
        <Divider hidden />
      </Form>
    )
  }
}

UserChangePassword = connect(mapStateToProps, mapDispatchToProps)(
  UserChangePassword
)
UserChangePassword = reduxForm({
  form: 'change_password',
  validate: validatePasswordsMatch,
})(UserChangePassword)
export default withRouter(UserChangePassword)



// WEBPACK FOOTER //
// ./src/components/admin/Users/UserChangePassword.jsx